import React from 'react';
import { Layout } from '@/components/Layout';
import { ShieldAlert, AlertCircle, HelpCircle } from 'lucide-react';

export default function Disclaimer() {
  const items = [
    { 
      title: '关于平台', 
      content: '万象聚聚官 2135C 仅作为教程聚合与导航平台存在。本网站所收录的所有链接、教程、资料与内容，均来源于网络公开资源或用户投稿，仅供学习交流使用。',
      icon: <ShieldAlert className="h-5 w-5 text-red-500" />
    },
    { 
      title: '关于内容', 
      content: '本网站不存储、不修改、不编辑任何第三方内容，不对内容的准确性、完整性或合法性承担责任。',
      icon: <AlertCircle className="h-5 w-5 text-orange-500" />
    },
    { 
      title: '关于权利', 
      content: '如您认为本网站收录的内容涉及侵权，请通过联系方式通知我们，我们将在第一时间处理。',
      icon: <HelpCircle className="h-5 w-5 text-blue-500" />
    },
    { 
      title: '关于行为', 
      content: '用户点击外部链接产生的一切行为与本网站无关，本网站不承担任何法律责任。本网站对因使用本站内容、链接或服务而产生的任何损失不承担赔偿责任。',
      icon: <ShieldAlert className="h-5 w-5 text-red-500" />
    },
  ];

  return (
    <Layout>
      <div className="container mx-auto px-4 md:px-6 py-12 max-w-4xl">
        <div className="flex flex-col items-center text-center mb-12">
          <div className="bg-primary/10 p-4 rounded-2xl mb-4 text-primary">
            <ShieldAlert className="h-8 w-8" />
          </div>
          <h1 className="text-4xl font-extrabold tracking-tight mb-4">免责声明</h1>
          <p className="text-muted-foreground text-lg max-w-xl">
            使用本网站即表示您已阅读并同意本免责声明的全部条款。
          </p>
        </div>

        <div className="grid gap-6">
          {items.map((item, idx) => (
            <div key={idx} className="bg-card border rounded-3xl p-8 shadow-sm flex flex-col md:flex-row gap-6 items-start hover:border-primary/20 transition-colors">
              <div className="p-3 bg-muted/50 rounded-2xl shrink-0">
                {item.icon}
              </div>
              <div className="space-y-4">
                <h2 className="text-2xl font-bold">{item.title}</h2>
                <p className="text-muted-foreground leading-relaxed">
                  {item.content}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center text-xs text-muted-foreground italic">
          <p>更新日期：2026-03-18 (UTC)</p>
        </div>
      </div>
    </Layout>
  );
}
